<recaptcha [size]="'invisible'"
           [badge]="'bottomleft'"
           [hide]="false"
           (captchaResponse)="onCaptchaResponse($event)">
</recaptcha>

<!-- header -->
<sign-up-header></sign-up-header>

<!-- main content -->
<div class="main-content-container">
    <div class="container-spaced">

        <!-- 1st column: Features -->
        <!--<options [package]="package" [licenseType]="licenseType"></options>-->

        <!-- 2nd column: Sign-Up View -->
        <div #secondColumn class="main-container cnt-column-centered g4Border">

            <!-- Sign-up steps -->
            <!--<sign-up-steps [firstForm]="true" [licenseType]="licenseType"></sign-up-steps>-->
            <!-- Main container -->
            <div class="create-account-bgrnd cnt-column-centered" data-testid="winRegister">
                <div [height]="20"></div>

                <!-- Header of step -->
                <div class="cnt-column-centered">
                    <div>
                        <div class="step-tittle text-align-left b4Color" i18n>{{ 'CREATE_YOUR' | translate }} {{isBusinessDoctors ? '' : 'Brixx'}} {{ 'ACCOUNT' | translate }}</div>
                    </div>
                    <div [height]="5"></div>
                    <div>
                        <span class="p2Font signin-text b4Color">
                            <ng-container i18n>{{ 'ALREADY_HAVE' | translate }} {{isBusinessDoctors ? 'an' : ' a Brixx'}} {{ 'ACCOUNT' | translate }}? - </ng-container>
                            <a (click)="goToSignIn()" class="termsLabel" i18n>{{ 'LOG_IN' | translate }}</a>
                        </span>
                    </div>
                </div>

                <div [height]="5"></div>

                <!-- Combobox container -->
                <div class="cnt-column-centered combobox_width">
                    <div [height]="10"></div>
                    <div class="input-container" style="max-width: 430px">
                        <input #emailInput
                               id="email"
                               [(ngModel)]="newUser.email"
                               class="default-input"
                               type="email"
                               name="email"
                               i18n-placeholder
                               [placeholder]="'EMAIL_ADDRESS' | translate"
                               autocomplete="off"
                               [height]="40"
                               maxlength="100"
                               (focusout)="validateEmail()"
                               data-testid="regEmail-edit-input">
                        <div #emailWrongMsg class="validation-failed-message" data-testid="regEmail-edit-validityMark">​</div>
                    </div>
                    <div [height]="2"></div>
                    <div class="input-container">
                        <input [hidden]="true"
                               #confirmEmailInput
                               id="confirmemail"
                               [(ngModel)]="newUser.email"
                               class="default-input"
                               type="email"
                               name="confirmemail"
                               i18n-placeholder
                               [placeholder]="'CONFIRM_YOUR_EMAIL_ADDRESS' | translate"
                               autocomplete="off"
                               [height]="40"
                               maxlength="100"
                               [blockCopyPaste]="isCopyPasteBlocked"
                               (focusout)="validateEmail()"
                               data-testid="regEmail-confirm-edit-input">
                        <div [hidden]="true" #confirmEmailWrongMsg class="validation-failed-message" data-testid="regEmail-confirm-edit-validityMark">​</div>
                    </div>
                    <div [height]="2"></div>
                    <div class="input-container">
                        <input #passwordInput id="password" [(ngModel)]="newUser.passwordStr" (keyup)="onPasswordType()" class="default-input" type="password" name="password"
                               i18n-placeholder [placeholder]="'ENTER_A_PASSWORD' | translate" maxlength="48" minlength="8" autocomplete="off" [height]="40"
                               (focusout)="validatePassword()" data-testid="registerPass-edit-input">
                        <div #pwdEye class="eye_password_hint eye_password-position" (click)="onPasswordSwitcher()"></div>
                    </div>

                    <!-- Password validation message -->
                    <div #passwordWrongMsg class="validation-failed-message" style="margin-top: -2px;margin-bottom: -5px;" data-testid="registerPass-edit-validityMark">​</div>
                    <!-- Password hints container -->
                    <div #pwdHints class="pwdHints" data-testid="pwdHints">
                        <div><div id="minLengthCheckMark" class="checkmark"></div><span i18n>8+{{ 'CHAR' | translate }}</span></div>
                        <div><div id="specialCheckMark" class="checkmark"></div><span i18n>{{ 'NUMBER_SPECIAL' | translate }}</span></div>
                        <div><div id="uppercaseCheckMark" class="checkmark"></div><span i18n>{{ 'UPPERCASE' | translate }}</span></div>
                        <div><div id="lowercaseCheckMark" class="checkmark"></div><span i18n>{{ 'LOWERCASE' | translate }}</span></div>
                    </div>
                </div>

                <div [height]="10"></div>

                <div *ngIf="!isBusinessDoctors" id="newsCheckBoxContainer" class="checkboxContainer">
                    <input type="checkbox" (change)="toggleGetNews()" id="newsCheckBox" name="newsCheckBox" class="checkboxLeft newsCheckBox">
                    <label for="newsCheckBox" data-testid="sendNewsCheckBox" style="width: 100%">
                        <span class="b4Color" id="firstNewsRow" i18n>{{ 'YOU_CAN_CONTACT_ME' | translate }}</span>
                    </label>
                </div>

                <!-- Create btn container -->
                <div class="cnt-column-centered" [ngStyle]="{'margin-top': isBusinessDoctors ? '0' : '20px'}">
                    <div class="cnt-row-centered">
                        <!--<div class="brixxLogo-small"></div>-->
                        <simple-btn #signUpBtn
                                    class=""
                                    [hoverTextColor]="'white'"
                                    [backgroundFillCls]="'o2Background'"
                                    [hoverFillCls]="'o1Background'"
                                    [boxShadowCls]="'primary-shadow'"
                                    [text]="createAccountButtonText | translate"
                                    [textCls]="'large-btn-text-500 m-auto'"
                                    [height]="40"
                                    [width]="240"
                                    [cornerRadius]="30"
                                    [horizontalPadding]="20"
                                    (click)="signUp()"
                                    data-testid="winRegistreSignUpBtn">
                        </simple-btn>
                    </div>
                </div>

                <div [height]="10"></div>

                <div class="cnt-column-centered">
                    <div class="cnt-row" style="align-items: center">
                        <div class="small-separating-line"></div>
                        <div class="separating-text-offset p1Font" i18n>{{ 'OR' | translate }}</div>
                        <div class="small-separating-line"></div>
                    </div>
                </div>

                <!--<span class="text-align-left p2Font b4Color" style="letter-spacing: 0.5px;" i18n>Or you can use your Crunch or Xero Account to sign in to Brixx</span>-->
                <!-- Alternative sign-up container -->
                <div class="cnt-column-centered">
                    <simple-btn #xeroSignUpBtn
                                class="signup-btn integration_button"
                                [text]="xeroSignUpButtonText | translate"
                                [textCls]="'large-btn-text-500 m-auto'"
                                [height]="50"
                                [width]="310"
                                [cornerRadius]="16"
                                [backgroundFillCls]="'transparent-background'"
                                [hoverFillCls]="'sso-button-hover'"
                                [borderWidth]=2
                                [borderColorCls]="'xeroBorder'"
                                [hoverBorderColorCls]="'xeroBorder'"
                                [textColorCls]="'b1color'"
                                [hoverTextColorCls]="'b1color'"
                                [leftImgCls]="'xeroLogo-small m-left-10'"
                                (click)="integrationSignUp(integrationCompany.Xero)"
                                data-testid="xeroSignUpBtn"
                                [ignoreLeftSpace]="true">
                    </simple-btn>
                    <simple-btn #crunchSignUpBtn
                    						*ngIf="isCrunchButtonVisible"
                                class="integration_button"
                                [text]="crunchSignUpButtonText | translate"
                                [textCls]="'large-btn-text-500 m-auto'"
                                [height]="50"
                                [width]="310"
                                [cornerRadius]="16"
                                [backgroundFillCls]="'transparent-background'"
                                [hoverFillCls]="'sso-button-hover'"
                                [borderWidth]=2
                                [borderColorCls]="'crunchBorderColor'"
                                [hoverBorderColorCls]="'crunchBorderColor'"
                                [textColorCls]="'b1color'"
                                [hoverTextColorCls]="'b1color'"
                                [leftImgCls]="'crunchLogo-small m-left-10'"
                                (click)="integrationSignUp(integrationCompany.Crunch)"
                                data-testid="crunchSignUpBtn"
                                [ignoreLeftSpace]="true">
                    </simple-btn>
                    <simple-btn #googleSignUpBtn
                                class="integration_button"
                                [text]="googleSignUpButtonText | translate"
                                [textCls]="'large-btn-text-500 m-auto'"
                                [height]="50"
                                [width]="310"
                                [cornerRadius]="16"
                                [backgroundFillCls]="'transparent-background'"
                                [hoverFillCls]="'sso-button-hover'"
                                [borderWidth]=2
                                [borderColorCls]="'googleBorder'"
                                [hoverBorderColorCls]="'googleBorder'"
                                [textColorCls]="'b1color'"
                                [hoverTextColorCls]="'b1color'"
                                [leftImgCls]="'googleLogo-small m-left-10'"
                                (click)="integrationSignUp(integrationCompany.Google)"
                                data-testid="googleSignUpBtn"
                                [ignoreLeftSpace]="true">
                    </simple-btn>
                    <simple-btn #facebookSignUpBtn
                                class="integration_button"
                                [text]="facebookSignUpButtonText | translate"
                                [textCls]="'large-btn-text-500 m-auto'"
                                [height]="50"
                                [width]="310"
                                [cornerRadius]="16"
                                [backgroundFillCls]="'transparent-background'"
                                [hoverFillCls]="'sso-button-hover'"
                                [borderWidth]=2
                                [borderColorCls]="'facebookBorder'"
                                [hoverBorderColorCls]="'facebookBorder'"
                                [textColorCls]="'b1color'"
                                [hoverTextColorCls]="'b1color'"
                                [leftImgCls]="'facebookLogo-small m-left-10'"
                                (click)="integrationSignUp(integrationCompany.Facebook)"
                                data-testid="facebookSignUpBtn"
                                [ignoreLeftSpace]="true">
                    </simple-btn>
                    <simple-btn #appleSignUpBtn
                                *ngIf="isAppleButtonVisible"
                                class="integration_button"
                                [text]="appleSignUpButtonText | translate"
                                [textCls]="'large-btn-text-500 m-auto'"
                                [height]="50"
                                [width]="310"
                                [cornerRadius]="16"
                                [backgroundFillCls]="'transparent-background'"
                                [hoverFillCls]="'sso-button-hover'"
                                [borderWidth]=2
                                [borderColorCls]="'appleBorder'"
                                [hoverBorderColorCls]="'appleBorder'"
                                [textColorCls]="'b1color'"
                                [hoverTextColorCls]="'b1color'"
                                [leftImgCls]="'appleLogo-small m-left-10'"
                                (click)="integrationSignUp(integrationCompany.Apple)"
                                data-testid="appleSignUpBtn"
                                [ignoreLeftSpace]="true">
                    </simple-btn>
                </div>

                <div [height]="13"></div>

                <!-- Term block -->
                <div class="terms-block">
                    <!--<div id="newsCheckBoxContainer" class="checkboxContainer">
            <input type="checkbox" (change)="toggleGetNews()" id="newsCheckBox" name="newsCheckBox" class="checkboxLeft newsCheckBox">
            <label for="newsCheckBox" data-testid="sendNewsCheckBox" style="width: 100%">
                <span class="b4Color" id="firstNewsRow" i18n>Tick this box if you would like&nbsp;</span>
                <span class="b4Color" id="secondNewsRow" i18n>recieve regular Brixx updates</span>
            </label>
        </div>
        <div [height]="13"></div>-->
                    <div class="b4Color" style="letter-spacing: 0.5px;">
                        <ng-container i18n>{{ 'BY_CREATING_AN_ACCOUNT' | translate }}</ng-container>
                        <a class="termsLabel" href="https://www.brixx.com/terms-conditions/" target="_blank" i18n>{{ 'TERMS' | translate }} &amp; {{ 'CONDITIONS' | translate }}</a>
                        <span>&nbsp;&&nbsp;</span><a class="termsLabel" href="https://www.brixx.com/privacy-policy/" target="_blank" i18n>{{ 'PRIVACY_POLICY' | translate }}</a>
                    </div>
                </div>
            </div>
        </div>

        <!--<div [width]="600" style="margin-left:80px;"></div>-->

    </div>
</div>